import { useMemo, useState } from "react";

import { spellIconUrls } from "../data/icons";

interface Props {
  icon?: string | null;
  alt?: string;
  size?: number;
  className?: string;
}

/**
 * Small spell/ability icon. Walks a fallback chain (local → Wowhead) on
 * load failure, then degrades to a quiet placeholder square when no URL
 * resolves. Mirrors the behavior of PlayerCell's class-icon chain.
 */
export default function SpellIcon({ icon, alt = "", size = 16, className }: Props) {
  const candidates = useMemo(() => spellIconUrls(icon), [icon]);
  const [idx, setIdx] = useState(0);
  const url = idx < candidates.length ? candidates[idx] : null;

  if (!url) {
    return (
      <span
        className={`inline-block flex-shrink-0 rounded-sm border border-border bg-bg/40 ${className ?? ""}`}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <img
      // Re-mount on each new candidate so a 4xx-cached URL doesn't block
      // the retry attempt.
      key={url}
      src={url}
      alt={alt}
      loading="lazy"
      onError={() => setIdx((i) => i + 1)}
      className={`inline-block flex-shrink-0 rounded-sm border border-black/40 ${className ?? ""}`}
      style={{ width: size, height: size }}
    />
  );
}
